import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'dateTimeToLocalTz'
})
export class DateTimeToLocalTzPipe implements PipeTransform {

    transform(value: DateTime): DateTime {
        return DateTime.isDateTime(value)
            ? value.setZone(DateTime.local().zoneName)
            : value;
    }

}

@Pipe({
    name: 'dateTimeToTz'
})
export class DateTimeToTzPipe implements PipeTransform {

    transform(value: DateTime, zoneName: string): DateTime {
        return DateTime.isDateTime(value)
            ? value.setZone(zoneName)
            : value;
    }

}
